import { AnchorComponent } from './Anchor';
export default AnchorComponent;
